// this is an autogenerated file from DesignSystem/TasksViewForm/Content/Content/Tags/TagsPicker/Content/mutation-create-tag.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksViewForm_Content_Content_Tags_TagsPicker_Content($name: String!) {
  insert_tasks_tags_one(object: { type: TASK, name: $name }) {
    id
    name
  }
}

`